import SelectDropDown from 'Components/SelectDropDown';
import { initializeArrayWithRange } from 'utils/initializeArrayWithRange';

interface IYearSelector {
  year: number;
  onChange: (year: number) => void;
}

const YearSelector = ({ year, onChange }: IYearSelector) => {
  return (
    <div className="w-[200px]">
      <SelectDropDown
        options={initializeArrayWithRange(2020, new Date().getFullYear())
          .reverse()
          .map((year) => ({ id: year, label: String(year) }))}
        onChange={(y) => y && onChange(+y)}
        value={year}
      />
    </div>
  );
};

export default YearSelector;
